<template>
  <div class="d-block" :class="[{ 'p-3': paddingTop }, { 'px-3 pb-3': !paddingTop }]">
    <div class="d-flex flex-fill">
      <div class="img-wrap d-flex justify-content-center">
        <img :src="iconSrc" alt="Disclaimer Icon" />
      </div>
      <h3 class="card-title mb-3 mt-0 pl-3">{{ title }}</h3>
    </div>
    <div class="d-flex flex-fill">
      <p class="mt-md-0 mt-0" v-if="text" v-html-safe="text" :class="{ 'text-left-space': textLeftSpace }"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerCard',
  props: {
    iconSrc: {
      type: [Object, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    paddingTop: {
      type: Boolean,
      default: true,
    },
    textLeftSpace: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.card-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}
p {
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 0;
}
.img-wrap {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f0f4f7;
  img {
    width: 49px;
    height: auto;
    padding: 25%;
  }
}
.text-left-space {
  margin-left: 48px;
  padding-left: 1rem;
}
</style>
